/**
 * @generated SignedSource<<4ac7f2ee2db8a67ca5594c4bdd4b649f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PostStatusEnum = "ACF_DISABLED" | "AUTO_DRAFT" | "DRAFT" | "FAILED" | "FUTURE" | "HIDDEN" | "HIDDEN_B_S" | "INHERIT" | "IN_PROGRESS" | "PENDING" | "PRIVATE" | "PUBLISH" | "REQUEST_COMPLETED" | "REQUEST_CONFIRMED" | "REQUEST_FAILED" | "REQUEST_PENDING" | "TRASH";
export type StatusUiPermissionEnum = "PUBLIC" | "RESTRICTED";
export type ZnglistTemplateTypeEnum = "CLASSIC" | "PENDING" | "PERSONAL";
export type ZnglistUserTypeEnum = "ADMIN" | "USER";
export type UpdateZnglistInput = {
  authorId?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  date?: string | null | undefined;
  formId?: string | null | undefined;
  id: string;
  ignoreEditLock?: boolean | null | undefined;
  menuOrder?: number | null | undefined;
  order?: number | null | undefined;
  password?: string | null | undefined;
  slug?: string | null | undefined;
  status?: PostStatusEnum | null | undefined;
  statusSettings?: StatusSettingsInput | null | undefined;
  templateType?: ZnglistTemplateTypeEnum | null | undefined;
  title?: string | null | undefined;
  userType?: ZnglistUserTypeEnum | null | undefined;
  znglyContents?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type StatusSettingsInput = {
  approved?: ApprovedStateInput | null | undefined;
  stateWhenApproved?: StateWhenApprovedInput | null | undefined;
  status?: PostStatusEnum | null | undefined;
  uiPermission?: UIPermissionInput | null | undefined;
};
export type ApprovedStateInput = {
  id?: string | null | undefined;
};
export type StateWhenApprovedInput = {
  status?: PostStatusEnum | null | undefined;
  uiPermission?: UIPermissionInput | null | undefined;
};
export type UIPermissionInput = {
  type?: StatusUiPermissionEnum | null | undefined;
};
export type Znglist_UpdateZnglistOrder_Mutation$variables = {
  input: UpdateZnglistInput;
};
export type Znglist_UpdateZnglistOrder_Mutation$data = {
  readonly updateZnglist: {
    readonly znglist: {
      readonly id: string;
      readonly znglist: {
        readonly order: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type Znglist_UpdateZnglistOrder_Mutation$rawResponse = {
  readonly updateZnglist: {
    readonly znglist: {
      readonly id: string;
      readonly znglist: {
        readonly order: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type Znglist_UpdateZnglistOrder_Mutation = {
  rawResponse: Znglist_UpdateZnglistOrder_Mutation$rawResponse;
  response: Znglist_UpdateZnglistOrder_Mutation$data;
  variables: Znglist_UpdateZnglistOrder_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateZnglistPayload",
    "kind": "LinkedField",
    "name": "updateZnglist",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Znglist",
        "kind": "LinkedField",
        "name": "znglist",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Znglist_Znglist",
            "kind": "LinkedField",
            "name": "znglist",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "order",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Znglist_UpdateZnglistOrder_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Znglist_UpdateZnglistOrder_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7c7c6fa80930e102dbf1c51c5dc2b090",
    "id": null,
    "metadata": {},
    "name": "Znglist_UpdateZnglistOrder_Mutation",
    "operationKind": "mutation",
    "text": "mutation Znglist_UpdateZnglistOrder_Mutation(\n  $input: UpdateZnglistInput!\n) {\n  updateZnglist(input: $input) {\n    znglist {\n      id\n      znglist {\n        order\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "33b85941b5f3f2ac1de530edfff35623";

export default node;
